import React from 'react'
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { corporateColor, lightBackground } from '../../../../../../theme/colors'
import moment from 'moment'
import { PhotoTypes } from '../../../../../../context/Logistics/fuel/types'
import { DOBRA } from '../../../../../../theme/fonts'
import { useTranslation } from 'react-i18next'

interface Props {
  hasBg?: boolean
  label?: string
  date: number
  uri: string
  title: string
  photoType: PhotoTypes
  onPress?: (values: { uri: string; photoType: PhotoTypes }) => void
}

export const Card = ({ hasBg, date, label, uri, title, onPress, photoType }: Props) => {
  const formattedDate = moment(date).format('DD/MM/YYYY - HH:mm')
  const { t } = useTranslation()
  const Container = onPress ? TouchableOpacity : View
  return (
    <Container
      onPress={onPress ? () => onPress({ photoType, uri }) : undefined}
      style={[
        style.container,
        hasBg && {
          backgroundColor: lightBackground,
        },
      ]}
    >
      <View
        style={{
          width: 80,
          height: 80,
        }}
      >
        {!uri && (
          <>
            <Image
              // eslint-disable-next-line @typescript-eslint/no-require-imports
              source={require('../../../../../../assets/add-photo.png')}
              resizeMode='cover'
              style={{ width: '100%', height: '100%', borderRadius: 10 }}
            />
            <Text style={[style.label, { textAlign: 'center' }]}>{t('Añadir foto')}</Text>
          </>
        )}
        {uri && uri != null && uri.length > 0 && (
          <Image
            source={{ uri }}
            resizeMode='cover'
            style={{ width: '100%', height: '100%', borderRadius: 10 }}
          />
        )}
      </View>

      <View style={{ justifyContent: 'space-evenly', flexGrow: 1 }}>
        <Text style={style.title}>{title}</Text>
        <Text style={style.label}>
          {t('Fecha')}: {formattedDate}
        </Text>
        {label && <Text style={style.label}>{label}</Text>}
      </View>
    </Container>
  )
}

const style = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 20,
    paddingHorizontal: 24,
    paddingVertical: 8,
  },
  title: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: corporateColor,
  },
  label: {
    fontFamily: DOBRA,
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 17.5,
    color: corporateColor,
  },
})
